import * as pt from "@cicada-lang/partech";
import {} from "../../rule/index.js";
import * as matchers from "../matchers/index.js";
export function rule_target_matcher(tree) {
    return pt.matcher({
        "rule_target:rule_target": ({ name, parameters }, { span }) => ({
            name: pt.str(name),
            parameters: matchers.parameters_without_type_matcher(parameters),
        }),
    })(tree);
}
//# sourceMappingURL=rule_target_matcher.js.map